<div id="snackbar">
  <span matSnackBarLabel [innerHTML]="mitteilung[0].content | mitteilung:kunde:mandant:mitteilung[0].art">
  </span>
  <span matSnackBarActions>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">OK</button>
  </span>
</div>
